import { LogInBtn } from 'components';

import { BcAlert } from '@britishcouncil/react-solas-ors3';

export const ActivationSuccess = () => {
  return (
    <BcAlert type="success" title="Success">
      <p>
        Your account has been activated. Please, <LogInBtn /> to the system.
      </p>
    </BcAlert>
  );
};

export const OnlyMigrationSuccess = () => {
  return (
    <BcAlert type="success" title="Success">
      <p>
        Your account has been migrated. Please, <LogInBtn /> to the system.
      </p>
    </BcAlert>
  );
};
